import axios from "axios";
const instance = axios.create({
    baseURL: `https://api.themoviedb.org/3`,
    'Access-Control-Allow-Origin' : '*',
    'Access-Control-Allow-Methods':'GET,PUT,POST,DELETE,PATCH,OPTIONS',
});
export default instance;
